import { useQuery } from '@tanstack/react-query';
import { fetchCostTypesAdmin } from '../api/costTypesApi';

export default function useAdminCostTypes() {
    return useQuery({
        queryKey: ['adminCostTypes'],
        queryFn: fetchCostTypesAdmin,
        staleTime: 0,
    });
}
